<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
      <h2 class="editor-header">{{ updateRecord.id > 0 ? $t('common.edit') : $t('common.add_new')}} </h2>
      <div class="col-sm-12 form-data nopads">
        <div class="nopads pl-1 pr-1">
          <span class="span-title">
            {{ $t('users.company') }}
          </span>
            <select
                id="company"
                v-model="company"
                class="form-select form-select-sm mb-3"
                :disabled="!companies || companies.length < 1"
            >
                <option :value="null" disabled>
                    {{ $t('users.select_company') }}
                </option>
                <option v-for="c in companies" :key="c.id" :value="c.id">
                    {{ c.name }}
                </option>
            </select>
        </div>
        <div class="row">
          <div class="col-sm-6 nopads pl-1 pr-1">
            <span class="span-title">
              {{ $t('common.id') }}
            </span>
            <input
                id="name"
                v-model="updateRecord.external_id"
                type="text"
                class="form-control form-control-sm"
            />
          </div>
          <div class="col-sm-6 nopads pl-1 pr-1">
            <span class="span-title">
              {{ $t('common.name') }}
            </span>
            <input
                  id="name"
                  v-model="updateRecord.external_name"
                  type="text"
                  class="form-control form-control-sm"
            />
          </div>
        </div>
        <span class="span-title">{{ $t('inspection_editor.inactive') }}</span>
        <input
              id="in_active"
              v-model="updateRecord.inactive"
              type="checkbox"
              :checked="updateRecord.inactive === true"
              :value="true"
              class="form-check-input form-check-input-sm"
        />
        <!-- Buttons -->
        <div class="col-sm-12 button-container">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading || !company || !updateRecord.external_name || !updateRecord.external_id" @click.stop="submit">
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import {inject} from "vue";

export default {
    name: 'ExternalContractIdEditor',
    mixins: [restApi],
    props: {
        record: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            company: null,
            companies: [],
            updateRecord: null,
        }
    },

    created: function () {
        this.updateRecord = this.record
        this.fetchCompanies()
        this.company = this.updateRecord.company ? this.updateRecord.company.id : null
    },

    methods: {
        fetchCompanies: function () {
            this.loading = true
            this.restFetch(this.companyUrl, this.handleCompanies)
        },

        handleCompanies: function (response) {
            this.companies = response.data
            this.loading = false
        },

        submit: function () {
            this.loading = true
            this.updateRecord.company = {id: this.company}
            if (this.updateRecord.id < 1) {
                this.restAdd(this.extContractIdUrl, this.updateRecord, this.success, this.fail)
            } else {
                this.restUpdate(this.extContractIdUrl, this.updateRecord, this.success, this.fail)
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }
    }
}
</script>

